import styled from "@emotion/styled";

import { ShadowToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { IRecurlyCoupon } from "store/entities/recurly";
import { withVar } from "themes/helpers";

import { CouponTooltip } from "../../components/coupon-tooltip/CouponTooltip";

export interface IProps {
  coupon: IRecurlyCoupon | null;
}

export const CouponRow = ({ coupon }: IProps): JSX.Element => (
  <Container>
    <CouponTitle bold>Coupon</CouponTitle>
    <CouponTooltip coupon={coupon} />
    <CouponCode>
      {coupon?.code} (save {coupon?.discount.suffixValue})
    </CouponCode>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: ${withVar(SpacingToken.Spacing4)} 0;
  box-shadow: ${withVar(ShadowToken.DividerBottom)};
`;

const CouponTitle = styled(Text)`
  margin-right: ${withVar(SpacingToken.Spacing1)};
`;

const CouponCode = styled(Text)`
  margin-left: auto;
`;
